import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import type Owner from '@ember/owner';
import Component from '@glimmer/component';

import themeClasses from 'webapp/helpers/theme-classes';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import CustomQuerySetupApiMetricBuilderParamsOrHeadersRowComponent from 'webapp/components/custom-query/setup/api-metric-builder/params-or-headers-row';

import type CustomMetricSetupFormApiMetricBuilder from 'webapp/models-custom/custom-metric-setup-form/api-metric-builder';
import HeaderOrQueryParameter from 'webapp/models-custom/custom-metric-setup-form/api-metric-builder/header-or-query-parameter';

interface Args {
	form: CustomMetricSetupFormApiMetricBuilder;
	model: HeaderOrQueryParameter[];
	isDisabled: boolean;
	theme: string;
	addItem: (item: HeaderOrQueryParameter) => void;
	removeItem: (item: HeaderOrQueryParameter) => void;
	onContentChange: () => void;
}

export default class CustomQuerySetupApiMetricBuilderParamsOrHeadersListComponent extends Component<Args> {
	constructor(owner: Owner, args: Args) {
		super(owner, args);
		if (!this.args.model.filter((item) => !item.hidden).length) {
			this.addRow();
		}
	}

	@action
	addRow(): void {
		const newHeaderOrQuery = new HeaderOrQueryParameter({ key: '', value: '' });
		this.args.addItem(newHeaderOrQuery);
	}

	@action
	removeRow(row: HeaderOrQueryParameter): void {
		this.args.removeItem(row);
	}
	<template>
		<div class="item-group {{themeClasses @theme}}">
			<div class="group row open">
				<div class="items">
					{{#each @model as |row|}}
						{{#unless row.hidden}}
							<CustomQuerySetupApiMetricBuilderParamsOrHeadersRowComponent
								@form={{@form}}
								@model={{row}}
								@isDisabled={{@isDisabled}}
								@theme={{@theme}}
								@remove={{fn this.removeRow row}}
							/>
						{{/unless}}
					{{/each}}
					<a class="add" {{on "click" this.addRow}}>
						<CommonUiIconComponent @name="Plus" @size="lg" />
					</a>
				</div>
			</div>
		</div>
	</template>
}
